<template>
  <div class="carousel">
    <ClientOnly>
      <Carousel
        :coverflow="coverflow"
        coverflow-centered
        :gap="20"
        :visible-items="visibleItems"
        :arrows="arrows"
        :increment="1"
        align-items="flex-start"
      >
        <CarouselItem v-for="(module, index) in row.modules" :key="index">
          <div class="carousel-item">
            <component
              :is="componentForType(module.type)"
              :value="module"
            />
          </div>
        </CarouselItem>
      </Carousel>
    </ClientOnly>
  </div>
</template>

<script>
import { contentFindOption } from '../../plugins/content'
import ContentGeneratorModulesProductBox from './modules/ProductBox.vue'
import CardBox from './modules/CardBox.vue'
import ContentGeneratorModulesMedia from './modules/Media.vue'
import { clientOnlyComponent } from '~/marketplace-front-core/utils/clientOnlyComponent'
export default {
  components: {
    ContentGeneratorModulesProductBox,
    CardBox,
    ContentGeneratorModulesMedia,
    Carousel: clientOnlyComponent(() => import('~/marketplace-front-core/components/shared/Carousel.vue')),
    CarouselItem: clientOnlyComponent(() => import('~/marketplace-front-core/components/shared/CarouselItem.vue'))
  },
  props: {
    row: { type: Object, default: null }
  },
  computed: {
    visibleItems () {
      return {
        desktop: contentFindOption(this.row.options, 'visibleElementsDesktop').value || 3,
        mobile: contentFindOption(this.row.options, 'visibleElementsMobile').value || 1
      }
    },
    arrows () {
      return {
        desktop: ['enabled', null].includes(contentFindOption(this.row.options, 'enabledArrowsDesktop').value),
        mobile: ['enabled'].includes(contentFindOption(this.row.options, 'enabledArrowsMobile').value)
      }
    },
    coverflow () {
      return {
        desktop: ['enabled', null].includes(contentFindOption(this.row.options, 'coverflowDesktop').value),
        mobile: ['enabled', null].includes(contentFindOption(this.row.options, 'coverflowMobile').value)
      }
    }
  },
  methods: {
    componentForType (type) {
      const map = {
        photo: 'ContentGeneratorModulesMedia',
        cardBox: 'CardBox',
        productBox: 'ContentGeneratorModulesProductBox'
      }
      return map[type] || 'ContentGeneratorModulesProductBox'
    }
  }
}
</script>

<style lang="scss" scoped>

.carousel {
  margin: 60px 0;
  max-width: 1344px;
    @include touch {
    padding: 0;
    overflow: hidden;
    width: calc(100% + 50px);
    margin: 60px -25px;
  }
}
</style>
